// extracted by mini-css-extract-plugin
export var rssContainer = "ShareWidget-module--rssContainer--22f82";
export var rssIcon = "ShareWidget-module--rssIcon--ad290";
export var shareWidget = "ShareWidget-module--shareWidget--b1ad8";